import { render } from "./bookinginfo.vue?vue&type=template&id=70b00241"
import script from "./bookinginfo.vue?vue&type=script&lang=js"
export * from "./bookinginfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__